/**
 * Client wrappers for the Crew Card callables
 * (suite-io/functions/src/handlers/crewcard/). Same shape as
 * bridgeCallables.js. Errors propagate as Firebase HttpsError; a
 * failed-precondition carries err.details.gaps.
 */
import { callable } from "../firebase.js";

const call = async (name, payload, options) => {
  const fn = callable(name, options);
  const result = await fn(payload);
  return result.data;
};

export const crewCardApi = {
  /** Build + send the card for one session. Returns { token, url, version, sent, failed }. */
  deploy: ({ jobDocId, sessionId, kind = "crew" }) => call("deployCrewCard", { jobDocId, sessionId, kind }, { timeout: 120000 }),
  /** Kill a link. Returns { ok: true }. */
  revoke: ({ token }) => call("revokeCrewCard", { token }),
  /** Attendee responses on the session's Google Calendar event. Returns { attendees: [{email, responseStatus}] }. */
  attendance: ({ eventId }) => call("calendarProxy", { action: "get_event", eventId }),
};
